// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AccessDisabled__container-daa1b7 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.AccessDisabled__title-ac882b {
  font: var(--font-title-6);
  letter-spacing: var(--font-spacing-title-6);
  color: var(--base-110);
  margin-bottom: 4px;
  text-align: center;
}

.AccessDisabled__sub-title-cd83b9 {
  font: var(--font-body-5);
  letter-spacing: var(--font-spacing-body-5);
  color: var(--base-80);
  max-width: 360px;
  text-align: center;
}

.AccessDisabled__logo-f7eecb {
  margin-bottom: 24px;
}

.AccessDisabled__logo-show-b72794 {
  display: none;
}

@media (max-width: 428px) {
  .AccessDisabled__logo-show-b72794 {
    display: inline-block;
    width: 80px;
    margin-bottom: 32px;
  }
  .AccessDisabled__sub-title-cd83b9 {
    max-width: 332px;
  }
}`, "",{"version":3,"sources":["webpack://./src/unauthorized/AccessDisabled/AccessDisabled.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,yBAAA;EACA,2CAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE;IACE,qBAAA;IACA,WAAA;IACA,mBAAA;EACF;EAEA;IACE,gBAAA;EAAF;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.title {\n  font: var(--font-title-6);\n  letter-spacing: var(--font-spacing-title-6);\n  color: var(--base-110);\n  margin-bottom: 4px;\n  text-align: center;\n}\n\n.sub-title {\n  font: var(--font-body-5);\n  letter-spacing: var(--font-spacing-body-5);\n  color: var(--base-80);\n  max-width: 360px;\n  text-align: center;\n}\n\n.logo {\n  margin-bottom: 24px;\n}\n\n.logo-show {\n  display: none;\n}\n\n@media (max-width: 428px) {\n  .logo-show {\n    display: inline-block;\n    width: 80px;\n    margin-bottom: 32px;\n  }\n\n  .sub-title {\n    max-width: 332px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AccessDisabled__container-daa1b7`,
	"title": `AccessDisabled__title-ac882b`,
	"sub-title": `AccessDisabled__sub-title-cd83b9`,
	"subTitle": `AccessDisabled__sub-title-cd83b9`,
	"logo": `AccessDisabled__logo-f7eecb`,
	"logo-show": `AccessDisabled__logo-show-b72794`,
	"logoShow": `AccessDisabled__logo-show-b72794`
};
module.exports = ___CSS_LOADER_EXPORT___;
